module.exports = __webpack_public_path__ + "img/tornado.014453d6.svg";